// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-personalloans-v2/calculators-personalloans-v2.component.scss
// module id = 810
// module chunks = 0